<script setup>
import { Head } from "@inertiajs/vue3";
import { computed } from "vue";
import { trans } from "laravel-vue-i18n";
import Banner from "@/Components/Banner.vue";
import ReferralModal from "@/Components/ReferralModal.vue";
import { applyTheme } from "@/helper.js";
import RobloxSidebar from "@/Components/RobloxSidebar.vue";
import RobloxFooter from "@/Components/RobloxFooter.vue";
import RobloxHelp from "@/Components/RobloxHelp.vue";

const props = defineProps({
    title: String,
    // Per-page meta description. Falls back to the generic Roblox-section one.
    description: {
        type: String,
        default: null,
    },
    showHelp: {
        type: Boolean,
        default: true,
    },
});
applyTheme();

const metaDescription = computed(
    () =>
        props.description ??
        trans(
            'ANYKOD | Robux at the best price. Robux at the best price on the market. Instant shipping. Guarantee. Support.'
        )
);
</script>
<template>
    <Head>
        <meta
            :content="metaDescription"
            name="description"
        />
        <meta
            :content="
                $t(
                    'robux, buy robux, cheap robux, roblox, anykod, anycode, anycod, fast robux, robux sale, robux discount, secure robux, safe robux, robux top up, robux recharge, robux gift'
                )
            "
            name="keywords"
        />
    </Head>
    <div class="h-screen flex flex-col justify-between">
        <RobloxSidebar />
        <Head :title="title" />
        <Banner />
        <div class="overflow-y-auto grow flex flex-col" scroll-region>
            <div class="grow main-gradient">
                <!-- Page Heading -->
                <header v-if="$slots.header" class="shadow-sm bg-transparent">
                    <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                        <slot name="header" />
                    </div>
                </header>
                <!-- Page Content -->
                <main>
                    <div>
                        <slot />
                        <RobloxHelp v-if="showHelp" />
                        <div class="py-8 flex justify-center">
                            <img
                                style="max-width: 380px; width: 100%"
                                src="/assets/img/roblox/logo.webp"
                                alt="logo"
                            />
                        </div>
                    </div>
                </main>
            </div>
            <RobloxFooter class="grow-0" />
        </div>
    </div>
    <ReferralModal />
</template>
<style lang="css">
.main-gradient {
    background: linear-gradient(
        to bottom,
        #3d0d8f,
        #4e24c3,
        #6542ff,
        #ac42ff,
        #f74792,
        #fec723
    );
}
</style>
